export default {
    title: 'bold',
    action: [ 'bold' ],
    description: 'Bold',
    icon: 'Bold',
};
